import type { FC } from "react";
import { PluralContent } from "src/shared/components/content";

interface Props {
  className: string;
  eventCount: number;
  venueCityName: Maybe<string>;
  venueStateProvinceName: Maybe<string>;
}

export const VenueSubtitle: FC<Props> = ({ className, eventCount, venueCityName, venueStateProvinceName }) => {
  const locationLabel = venueCityName
    ? venueStateProvinceName
      ? `${venueCityName}, ${venueStateProvinceName}`
      : venueCityName
    : null;

  return (
    <span className={className}>
      <PluralContent
        count={eventCount}
        none={{ id: "cid$#4281409#" }} // "No events"
        one={{ id: "cid$#4281411#" }} // "1 event"
        many={(count: number) => ({ id: "cid$#4281414#", params: [count] })} // "{0} events"
      />
      {locationLabel ? ` • ${locationLabel}` : null}
    </span>
  );
};
